<template>
  <DossierDocumentCard
    title="Limpeza dos Reservatórios de Água"
    :status-options="statusOptions"
    :multiple-status="true"
    :status-requires-validity="['possui_vigente', 'possui_provisorio']"
    :status-requires-upload="['possui_vigente', 'possui_provisorio']"
    :explainer-text="explainerText"
    :mode="mode"
    :not-applicable="false"
    :start-collapsed="startCollapsed"
    v-model="formData"
    save-endpoint="/rest-home/dossier/water-tank"
    upload-endpoint="/rest-home/dossier/water-tank/upload"
    @saved="onSaved"
    @error="onError"
  >
    <template #fields-before>
      <div class="dossier-module__fields">
        <!-- Empresa responsável pela limpeza -->
        <div class="dossier-module__field-group">
          <label class="dossier-module__label"
            >Empresa responsável pela limpeza</label
          >
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.company_name"
            dense
            outlined
            hide-details
            placeholder="Nome da empresa ou 'Equipe própria'"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.company_name || "—"
          }}</span>
        </div>

        <!-- Data da última limpeza -->
        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Data da última limpeza</label>
          <v-text-field
            v-if="!isViewMode"
            v-model="formData.last_cleaning_date"
            type="date"
            dense
            outlined
            hide-details
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">
            <i class="fas fa-calendar-alt mr-1"></i>
            {{ formatDateBR(formData.last_cleaning_date) }}
          </span>
        </div>

        <!-- Periodicidade -->
        <div
          class="dossier-module__field-group dossier-module__field-group--small"
        >
          <label class="dossier-module__label">Periodicidade</label>
          <v-select
            v-if="!isViewMode"
            v-model="formData.frequency"
            :items="frequencies"
            dense
            outlined
            hide-details
            placeholder="Selecione"
            class="dossier-module__input"
          />
          <span v-else class="dossier-module__view-value">{{
            formData.frequency || "—"
          }}</span>
        </div>
      </div>
    </template>
  </DossierDocumentCard>
</template>

<script>
import DossierDocumentCard from "../dossier/DossierDocumentCard.vue";

const EXPLAINER_TEXT = `
  A limpeza e desinfecção periódica dos reservatórios de água (caixas d'água e
  cisternas) é obrigatória conforme a Portaria MS nº 888/2021 e normas estaduais
  e municipais de vigilância sanitária.<br><br>
  O laudo ou certificado de limpeza deve ser emitido pela empresa responsável
  e conter: data de execução, responsável técnico, métodos utilizados e
  resultado da inspeção.<br><br>
  A periodicidade mínima recomendada é semestral, mas municípios podem exigir
  frequência maior.<br><br>
  O Sistema Clin não valida o conteúdo do documento, apenas registra sua
  existência para fins de organização e apresentação à fiscalização.
`;

export default {
  name: "DossierWaterTank",
  components: { DossierDocumentCard },
  props: {
    mode: {
      type: String,
      default: "edit",
      validator: (v) => ["edit", "view"].includes(v),
    },
    initialData: { type: Object, default: () => ({}) },
    startCollapsed: { type: Boolean, default: false },
  },
  data() {
    return {
      explainerText: EXPLAINER_TEXT,
      statusOptions: [
        { value: "possui_vigente", label: "Possui laudo/certificado vigente" },
        { value: "possui_provisorio", label: "Possui comprovante provisório" },
        { value: "em_elaboracao", label: "Limpeza agendada / em execução" },
        { value: "nao_possui", label: "Não possui (pendente)" },
      ],
      frequencies: [
        "Semestral",
        "Anual",
        "Trimestral",
        "Conforme exigência municipal",
      ],
      formData: {
        company_name: "",
        last_cleaning_date: null,
        frequency: null,
        status: [],
        validity_date: null,
        file_url: null,
        file_name: null,
        observations: "",
        ...this.flattenInitialData(),
      },
    };
  },
  computed: {
    isViewMode() {
      return this.mode === "view";
    },
  },
  watch: {
    initialData: {
      deep: true,
      handler() {
        Object.assign(this.formData, this.flattenInitialData());
      },
    },
  },
  methods: {
    flattenInitialData() {
      const d = this.initialData || {};
      return {
        company_name: d.company_name || "",
        last_cleaning_date: d.last_cleaning_date || null,
        frequency: d.frequency || null,
        status: d.status || [],
        validity_date: d.validity_date || null,
        file_url: d.file_url || null,
        file_name: d.file_name || null,
        observations: d.observations || "",
      };
    },
    onSaved(data) {
      this.$emit("saved", { module: "water_tank", data });
    },
    onError(errors) {
      this.$emit("error", { module: "water_tank", errors });
    },
    formatDateBR(dateStr) {
      if (!dateStr) return "—";
      const [y, m, d] = dateStr.split("-");
      return `${d}/${m}/${y}`;
    },
  },
};
</script>